/**
 * 注册账号只允许字母、数字和 `_-.`。
 * 这里把“输入阶段过滤”和“提交阶段兜底校验”共用的规则集中到一个地方，
 * 避免后续修改字符集时出现表单表现与提交校验不一致的问题。
 */
export const REGISTER_CLIENT_ACCOUNT_PATTERN = /^[A-Za-z0-9_.-]+$/;

const REGISTER_CLIENT_ACCOUNT_SANITIZE_PATTERN = /[^A-Za-z0-9_.-]/g;

/**
 * 输入框在 onChange / 粘贴后统一走这里清洗字符。
 * 这样用户在注册时不会把空格、中文或其它特殊字符带进表单状态，
 * 同时仍然保留最终的正则校验，兜住脚本赋值等非手工输入场景。
 */
export const normalizeRegisterClientAccount = (value?: string) =>
  String(value || '').replace(REGISTER_CLIENT_ACCOUNT_SANITIZE_PATTERN, '');

/**
 * 最终提交前的账号格式校验。
 * 这里不负责“是否为空”，空值仍交给 Form 的 required 规则单独提示，
 * 这样用户能拿到更准确的错误语义。
 */
export const isValidRegisterClientAccount = (value?: string) =>
  REGISTER_CLIENT_ACCOUNT_PATTERN.test(String(value || ''));
